/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import {
  ContactDetailsDialogConfig,
  contactDetailsDialogRoute,
  FormState,
  FormStateBuilder,
  JobFinderListItem,
} from '@gh/builder-shared';
import { AbstractSnapshotFormComponent, FormStateSnapshot } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { DialogService, setControlValue } from '@gh/core-ui';
import { filter$ } from '@gh/rx/operators';

import { JobFinancialsInfo } from '../../../resources/job-financials.model';
import { ContactType } from '@gh/builder-shared-data';

@Component({
  standalone: false,
  selector: 'gh-job-financials-top-form',
  templateUrl: 'job-financials-top-form.component.html',
  styleUrls: ['job-financials-top-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobFinancialsTopFormComponent extends AbstractSnapshotFormComponent<JobFinancialsInfo> {

  @Input() jobId: ID;
  @Input() jobActive: boolean;

  @Output() jobChange = new EventEmitter<JobFinderListItem>();

  constructor(private dialogService: DialogService,
              private formStateBuilder: FormStateBuilder) {
    super();
  }

  updateJob({ id, jobNumber, siteAddress, contactName }: JobFinderListItem): void {
    setControlValue(this.form.group, 'jobId', id);
    setControlValue(this.form.group, 'jobNumber', jobNumber);
    setControlValue(this.form.group, 'siteAddress', siteAddress);
    setControlValue(this.form.group, 'customerName', contactName);
  }

  openContact(): void {
    this.dialogService.openWithInput(contactDetailsDialogRoute, <ContactDetailsDialogConfig>{
      contactType: ContactType.Customer,
      contactId: this.state.value.customerId,
      parentTitle: 'lbl_job',
    }).afterClosed().pipe(
      filter$(Boolean))
      .subscribe((contact: any) => {
        setControlValue(this.form.group, 'customerName', contact.name);
        this.state.value.customerId = contact.contactId;
      });
  }

  protected buildForm(snapshot: FormStateSnapshot<JobFinancialsInfo>): FormState<JobFinancialsInfo> {
    return this.formStateBuilder.buildPlain({
      mode: this.mode,
      enabled: true,
      snapshot,
      children: {
        jobId: void 0,
        jobNumber: { enabled: false },
        customerName: { enabled: false },
        siteAddress: { enabled: false },
      },
    });
  }
}
